import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import Badge from '@mui/material/Badge';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { NavLink, Link } from 'react-router-dom';
import './Sidebar.css';
import { useCategory } from '../../CategoryContext';
import VerticalSelector from './VerticalSelector';
import Footnote from './Footnote/Footnote';
import { Button } from '@mui/material';

const Sidebar = () => {
  const { categories, verticals } = useCategory();
  const { vertical_id } = useParams();
  const location = useLocation();

  const primaryMenuItem = [
    { icon: <HomeOutlinedIcon />, text: 'Home' },
    {
      icon: <img src={`${process.env.PUBLIC_URL}/categoryIcons/publications.svg`} />,
      text: 'Publications',
      path: 'paper',
      count: 'papers',
    },
    {
      icon: <img src={`${process.env.PUBLIC_URL}/categoryIcons/patents.svg`} />,
      text: 'Patents',
      count: 'patents',
    },
    {
      icon: <img src={`${process.env.PUBLIC_URL}/categoryIcons/funding.svg`} />,
      text: 'Funding',
      path: 'grant',
      count: 'grants',
    },
    {
      icon: <img src={`${process.env.PUBLIC_URL}/categoryIcons/people.svg`} />,
      text: 'People',
      path: 'author',
      path2: 'inventor',
      count: 'people',
    },
    {
      icon: <img src={`${process.env.PUBLIC_URL}/categoryIcons/jobs.svg`} />,
      text: 'Jobs',
      count: 'jobs',
    },
    {
      icon: <img src={`${process.env.PUBLIC_URL}/categoryIcons/organizations.svg`} />,
      text: 'Organizations',
      count: 'organizations',
    },
    {
      icon: <img src={`${process.env.PUBLIC_URL}/categoryIcons/events.svg`} />,
      text: 'Events',
      count: 'events',
    },
    {
      icon: <img src={`${process.env.PUBLIC_URL}/categoryIcons/tutorials.svg`} />,
      text: 'Tutorials',
      count: 'tutorials',
    },
  ];

  const userMenuItems = [
    { icon: '', text: 'Account Details', path: 'account-details' },
    { icon: '', text: 'Subscription', path: 'subscription' },
    {
      icon: '',
      text: 'Private Verticals',
      path: 'draft-verticals',
    },
    {
      icon: '',
      text: 'My Verticals',
      path: 'my-verticals',
    },
    {
      icon: '',
      text: 'Joined Verticals',
      path: 'joined-verticals',
      count: verticals.filter((v) => v.status === 'Invited').length,
    },
    { icon: '', text: 'Connected Accounts', path: 'connected-accounts' },
    { icon: '', text: 'My Profiles', path: 'my-links' },
    {
      icon: '',
      text: 'Funding Filters',
      path: 'funding-filters',
    },
  ];

  const isProfilePage = location.pathname.includes('/profile');

  const getNavLinkPath = (item) => {
    if (isProfilePage) {
      return `/profile/${item.path}`;
    } else {
      return `/vertical/${vertical_id}/${(item.text || '').toLowerCase()}`;
    }
  };

  return (
    <div className="sidebar">
      {!isProfilePage && <VerticalSelector vertical_id={vertical_id} />}

      <div className="sidebar-menu">
        {!isProfilePage
          ? primaryMenuItem.map((item, index) => (
              <Badge
                key={index}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                badgeContent={categories[item.count]}
                max={9999}
                sx={{ display: 'block' }}
                showZero
                slotProps={{
                  badge: {
                    sx: {
                      backgroundColor: '#F4F5F7',
                      color: '#596274',
                      top: '10px',
                      border: '1px solid #356AC3',
                      fontSize: '12px',
                      fontWeight: '500',
                    }, // Apply styles specifically to badge content
                  },
                }}
              >
                <NavLink
                  key={index}
                  to={getNavLinkPath(item)}
                  className={({ isActive }) =>
                    isActive ||
                    location.pathname.includes(item.path) ||
                    location.pathname.includes(item.path2)
                      ? 'sidebar-item-active'
                      : 'sidebar-item'
                  }
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    pointerEvents:
                      !location.pathname.includes('vertical') &&
                      !location.pathname.includes('profile') &&
                      'none',
                  }}
                >
                  {item.icon}
                  <span>{item.text}</span>
                </NavLink>
              </Badge>
            ))
          : userMenuItems.map((item, index) => (
              <NavLink
                key={index}
                to={getNavLinkPath(item)}
                className={({ isActive }) =>
                  isActive || location.pathname.includes(item.path)
                    ? 'sidebar-item-active'
                    : 'sidebar-item'
                }
              >
                <span>{item.text}</span>
                {item.count > 0 && <div className="badge">{item.count}</div>}
              </NavLink>
            ))}
      </div>

      <div className="sidebarfooter">
        {vertical_id && (
          <Button
            variant="outlined"
            component={NavLink}
            to={`/vertical/${vertical_id}/workbench/vertical?tab=slack`}
            startIcon={<img src="/slack.svg" alt="Slack" style={{ width: 20, height: 20 }} />}
            sx={{ textTransform: 'none', marginBottom: '18px', width: '180px' }}
          >
            Vertical Slack
          </Button>
        )}

        <Button
          variant="contained"
          component={NavLink}
          to="/video-guides"
          sx={{ display: 'block', marginBottom: '18px', width: '180px' }}
        >
          Support
        </Button>
        <div className="box">
          <Link to={'https://www.simple-platform.com'} target="_blank">
            <img src={`${process.env.PUBLIC_URL + '/logo.svg?v=2'}`} alt="TSP logo" />
          </Link>
          <Footnote />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
